export function yearSelected(payload) {
  return {
    type: 'YEARSELECTED',
    payload: payload
  }
}

export function monthSelected(payload) {
  return {
    type: 'MONTHSELECTED',
    payload: payload
  }
}

export function daySelected(payload) {
  return {
    type: 'DAYSELECTED',
    payload: payload
  }
}

export function hourSelected(payload) {
  return {
    type: 'HOURSELECTED',
    payload: payload
  }
}

export function minuteSelected(payload) {
  return {
    type: 'MINUTESELECTED',
    payload: payload
  }
}